/**
 * long description for the file
 *
 * @summary provides an API for sending logs to LRS
 * @author dhrushit raval
 *
 * Created at     : 2019-02-20 15:13:51
 * Last modified  : 2019-02-21 12:39:45
 */

/**
 * TBD
 * add description for each field
 */

// import { v4 } from "uuid/interfaces";

// type definitions
export type IRI = string;
export type Metadata = any;
export type ActorObjectType = AgentObjectType | GroupObjectType;
export type AgentObjectType = "Agent";
export type GroupObjectType = "Group";
export type IFI = IMbox | IMboxSha1Sum | IOpenid | IAccount;

// console.log(IFI;

// interfaces
export interface IStatement {
    // id?: v4; // uuid
    id?: string; // uuid
    actor: Actor;
    verb: IVerb;
    object: IObject;
    result?: IResult;
    context?: IContext;
}

export interface IVerb {
    id: VerbIds;
    display: IVerbDisplay;
}

export interface IVerbDisplay {
    "en-US"?: string;
    "en"?: string;
}

export interface IObject {
    objectType?: string;
    id: ActivityTypes;
    definition?: Metadata;
}

export interface IActivity extends IObject {
    name: string;
    description: string;
    type: ActivityTypes;
}

export interface IResult {

}

export interface IContext {

}

export interface IActorBase {
    objectType: ActorObjectType;
    name?: string;
}

export interface IActor extends IActorBase {

}

export type Agent = IActorBase & IFI;
export type Group = IActorBase | IFI;
export type Actor = Agent | Group;

export type IFIKeys = "mbox" | "mbox_sha1sum" | "openid" | "account";

export interface IInverseFunctionalIdentifier {
    mbox?: string; // mailto:IRI Internationalized Resource Identifier
    mbox_sha1sum?: string; // String
    openid?: string; // URI
    account?: {}; // Object
}

export interface IMbox {
    mbox: string;
}

export interface IMboxSha1Sum {
    mbox_sha1sum: string;
}

export interface IOpenid {
    openid: string;
}

export interface IAccount {
    account: {};
}

// export type ifi = "mbox" | "mbox_sha1sum";
// export type ifi1 = { [key in ifi]: string };

export interface IGroup extends IActorBase {
    objectType: GroupObjectType;
    name?: string;
}

// export interface Ifi {
//     mbox: string;
//     mbox_sha: string;
// }

export interface IAnonymousGroup extends IGroup {

}

export enum VerbIds {
    ABANDONED = <any>"https=//w3id.org/xapi/adl/verbs/abandoned",
    ABLED = <any>"https=//w3id.org/xapi/dod-isd/verbs/abled",
    ACCESSED = <any>"https=//w3id.org/xapi/seriousgames/verbs/accessed",
    ACCLIMATIZED = <any>"https=//w3id.org/xapi/dod-isd/verbs/acclimatized",
    ACCOMMODATED = <any>"https=//w3id.org/xapi/dod-isd/verbs/accommodated",
    ACCOMPLISHED = <any>"https=//w3id.org/xapi/dod-isd/verbs/accomplished",
    ACHIEVED = <any>"https=//w3id.org/xapi/dod-isd/verbs/achieved",
    ACKNOWLEDGED = <any>"https=//w3id.org/xapi/dod-isd/verbs/acknowledged",
    ACTIVATED = <any>"https=//w3id.org/xapi/dod-isd/verbs/activated",
    ACTUATED = <any>"https=//w3id.org/xapi/dod-isd/verbs/actuated",
    ADAPTED = <any>"https=//w3id.org/xapi/dod-isd/verbs/adapted",
    ADJOURNED = <any>"http=//id.tincanapi.com/verb/adjourned",
    ADJUSTED = <any>"https=//w3id.org/xapi/dod-isd/verbs/adjusted",
    ADMINISTERED = <any>"https=//w3id.org/xapi/dod-isd/verbs/administered",
    ADVANCED = <any>"https=//w3id.org/xapi/dod-isd/verbs/advanced",
    ADVISED = <any>"https=//w3id.org/xapi/dod-isd/verbs/advised",
    ALERTED = <any>"https=//w3id.org/xapi/dod-isd/verbs/alerted",
    ALIGNED = <any>"https=//w3id.org/xapi/dod-isd/verbs/aligned",
    ALLOCATED = <any>"https=//w3id.org/xapi/dod-isd/verbs/allocated",
    ALLOWED = <any>"https=//w3id.org/xapi/dod-isd/verbs/allowed",
    ALTERED = <any>"https=//w3id.org/xapi/dod-isd/verbs/altered",
    AMBUSHED = <any>"https=//w3id.org/xapi/dod-isd/verbs/ambushed",
    ANALYZED = <any>"https=//w3id.org/xapi/dod-isd/verbs/analyzed",
    ANNOTATED = <any>"http=//risc-inc.com/annotator/verbs/annotated",
    ANNOUNCED = <any>"https=//w3id.org/xapi/dod-isd/verbs/announced",
    ANSWERED = <any>"http=//adlnet.gov/expapi/verbs/answered",
    APPLAUDED = <any>"http=//id.tincanapi.com/verb/applauded",
    APPLIED = <any>"https=//w3id.org/xapi/dod-isd/verbs/applied",
    APPRAISED = <any>"https=//w3id.org/xapi/dod-isd/verbs/appraised",
    APPRECIATED = <any>"https=//w3id.org/xapi/dod-isd/verbs/appreciated",
    APPROVED = <any>"https=//w3id.org/xapi/dod-isd/verbs/approved",
    ARCHIVED = <any>"https=//w3id.org/xapi/dod-isd/verbs/archived",
    ARMED = <any>"https=//w3id.org/xapi/dod-isd/verbs/armed",
    ARRANGED = <any>"http=//id.tincanapi.com/verb/arranged",
    ARRIVED = <any>"https=//w3id.org/xapi/adb/verbs/arrived",
    ASKED = <any>"http=//adlnet.gov/expapi/verbs/asked",
    ASSAULTED = <any>"https=//w3id.org/xapi/dod-isd/verbs/assaulted",
    ASSEMBLED = <any>"https=//w3id.org/xapi/dod-isd/verbs/assembled",
    ASSESSED = <any>"https=//w3id.org/xapi/dod-isd/verbs/assessed",
    ASSIGNED = <any>"https=//w3id.org/xapi/dod-isd/verbs/assigned",
    ASSISTED = <any>"https=//w3id.org/xapi/dod-isd/verbs/assisted",
    ASSUMED = <any>"https=//w3id.org/xapi/dod-isd/verbs/assumed",
    ATTACHED = <any>"https=//w3id.org/xapi/dod-isd/verbs/attached",
    ATTACKED = <any>"https=//w3id.org/xapi/dod-isd/verbs/attacked",
    ATTEMPTED = <any>"http=//adlnet.gov/expapi/verbs/attempted",
    ATTENDED = <any>"https=//w3id.org/xapi/adb/verbs/attended",
    ATTENDEDCLOSELY = <any>"https//w3id.org/xapi/dod-isd/verbs/attended-closely",
    AUTHENTICATED = <any>"https=//w3id.org/xapi/dod-isd/verbs/authenticated",
    BALANCED = <any>"https=//w3id.org/xapi/dod-isd/verbs/balanced",
    BELIEVED = <any>"https=//w3id.org/xapi/dod-isd/verbs/believed",
    BOOKMARKED = <any>"http=//id.tincanapi.com/verb/bookmarked",
    BREACHED = <any>"https=//w3id.org/xapi/dod-isd/verbs/breached",
    BRIEFED = <any>"https=//w3id.org/xapi/dod-isd/verbs/briefed",
    BYPASSED = <any>"https=//w3id.org/xapi/dod-isd/verbs/bypassed",
    CALCULATED = <any>"https=//w3id.org/xapi/dod-isd/verbs/calculated",
    CALIBRATED = <any>"https=//w3id.org/xapi/dod-isd/verbs/calibrated",
    CALLED = <any>"http=//id.tincanapi.com/verb/called",
    CAMOUFLAGED = <any>"https=//w3id.org/xapi/dod-isd/verbs/camouflaged",
    CANCELED = <any>"https=//w3id.org/xapi/dod-isd/verbs/canceled",
    CARRIED = <any>"https=//w3id.org/xapi/dod-isd/verbs/carried",
    CATEGORIZED = <any>"https=//w3id.org/xapi/dod-isd/verbs/categorized",
    CAUSED = <any>"https=//w3id.org/xapi/dod-isd/verbs/caused",
    CENTERED = <any>"https=//w3id.org/xapi/dod-isd/verbs/centered",
    CHALLENGED = <any>"https=//w3id.org/xapi/dod-isd/verbs/challenged",
    CHANGED = <any>"https=//w3id.org/xapi/dod-isd/verbs/changed",
    CHARGED = <any>"https=//w3id.org/xapi/dod-isd/verbs/charged",
    CHECKED = <any>"https=//w3id.org/xapi/dod-isd/verbs/checked",
    CHOSE = <any>"https=//w3id.org/xapi/dod-isd/verbs/chose",
    CLASSIFIED = <any>"https=//w3id.org/xapi/dod-isd/verbs/classified",
    CLEANED = <any>"https=//w3id.org/xapi/dod-isd/verbs/cleaned",
    CLEARED = <any>"https=//w3id.org/xapi/dod-isd/verbs/cleared",
    CLOSED = <any>"https=//w3id.org/xapi/dod-isd/verbs/closed",
    CLOSEDSALE = <any>"http//id.tincanapi.com/verb/closed-sale",
    COACHED = <any>"https=//w3id.org/xapi/adb/verbs/coached",
    COLLATED = <any>"https=//w3id.org/xapi/dod-isd/verbs/collated",
    COLLECTED = <any>"https=//w3id.org/xapi/dod-isd/verbs/collected",
    COMBINED = <any>"https=//w3id.org/xapi/dod-isd/verbs/combined",
    COMMANDED = <any>"https=//w3id.org/xapi/dod-isd/verbs/commanded",
    COMMENTED = <any>"http=//adlnet.gov/expapi/verbs/commented",
    COMMUNICATED = <any>"https=//w3id.org/xapi/dod-isd/verbs/communicated",
    COMPARED = <any>"https=//w3id.org/xapi/dod-isd/verbs/compared",
    COMPILED = <any>"https=//w3id.org/xapi/dod-isd/verbs/compiled",
    COMPLETED = <any>"http=//adlnet.gov/expapi/verbs/completed",
    COMPLETEDASSIGNMENT = <any>"https//w3id.org/xapi/dod-isd/verbs/completed-assignment",
    COMPLIED = <any>"https=//w3id.org/xapi/dod-isd/verbs/complied",
    COMPOSED = <any>"https=//w3id.org/xapi/dod-isd/verbs/composed",
    COMPUTED = <any>"https=//w3id.org/xapi/dod-isd/verbs/computed",
    CONCEIVED = <any>"https=//w3id.org/xapi/dod-isd/verbs/conceived",
    CONCLUDED = <any>"https=//w3id.org/xapi/dod-isd/verbs/concluded",
    CONDENSED = <any>"https=//w3id.org/xapi/dod-isd/verbs/condensed",
    CONDUCTED = <any>"https=//w3id.org/xapi/dod-isd/verbs/conducted",
    CONFIRMED = <any>"https=//w3id.org/xapi/dod-isd/verbs/confirmed",
    CONJECTURED = <any>"https=//w3id.org/xapi/dod-isd/verbs/conjectured",
    CONNECTED = <any>"https=//w3id.org/xapi/dod-isd/verbs/connected",
    CONSOLIDATED = <any>"https=//w3id.org/xapi/dod-isd/verbs/consolidated",
    CONSTRUCTED = <any>"https=//w3id.org/xapi/dod-isd/verbs/constructed",
    CONTRASTED = <any>"https=//w3id.org/xapi/dod-isd/verbs/contrasted",
    CONTRIVED = <any>"https=//w3id.org/xapi/dod-isd/verbs/contrived",
    CONTROLLED = <any>"https=//w3id.org/xapi/dod-isd/verbs/controlled",
    CONVERTED = <any>"https=//w3id.org/xapi/dod-isd/verbs/converted",
    COORDINATED = <any>"https=//w3id.org/xapi/dod-isd/verbs/coordinated",
    CORRECTED = <any>"https=//w3id.org/xapi/dod-isd/verbs/corrected",
    CORRELATED = <any>"https=//w3id.org/xapi/dod-isd/verbs/correlated",
    COVERED = <any>"https=//w3id.org/xapi/dod-isd/verbs/covered",
    CREATED = <any>"https=//w3id.org/xapi/dod-isd/verbs/created",
    CREATEDOPPORTUNIT = <any>"http//id.tincanapi.com/verb/created-opportunity",
    CREPT = <any>"https=//w3id.org/xapi/dod-isd/verbs/crept",
    CRITICIZED = <any>"https=//w3id.org/xapi/dod-isd/verbs/criticized",
    CROSSCHECKE = <any>"https//w3id.org/xapi/dod-isd/verbs/cross-checked",
    CROSSED = <any>"https=//w3id.org/xapi/dod-isd/verbs/crossed",
    DEBRIEFED = <any>"https=//w3id.org/xapi/dod-isd/verbs/debriefed",
    DEBUGGED = <any>"https=//w3id.org/xapi/dod-isd/verbs/debugged",
    DECIDED = <any>"https=//w3id.org/xapi/dod-isd/verbs/decided",
    DECONTAMINATED = <any>"https=//w3id.org/xapi/dod-isd/verbs/decontaminated",
    DEFENDED = <any>"https=//w3id.org/xapi/dod-isd/verbs/defended",
    DEFINED = <any>"http=//id.tincanapi.com/verb/defined",
    DELAYED = <any>"https=//w3id.org/xapi/dod-isd/verbs/delayed",
    DELETED = <any>"https=//w3id.org/xapi/dod-isd/verbs/deleted",
    DELIVERED = <any>"https=//w3id.org/xapi/dod-isd/verbs/delivered",
    DEMANDED = <any>"https=//w3id.org/xapi/adb/verbs/demanded",
    DEMONSTRATED = <any>"https=//w3id.org/xapi/dod-isd/verbs/demonstrated",
    DEPARTED = <any>"https=//w3id.org/xapi/dod-isd/verbs/departed",
    DEPLOYED = <any>"https=//w3id.org/xapi/dod-isd/verbs/deployed",
    DERIVED = <any>"https=//w3id.org/xapi/dod-isd/verbs/derived",
    DESCRIBED = <any>"https=//w3id.org/xapi/adb/verbs/described",
    DESIGNATED = <any>"https=//w3id.org/xapi/dod-isd/verbs/designated",
    DESIGNED = <any>"https=//w3id.org/xapi/acrossx/verbs/designed",
    DESTROYED = <any>"https=//w3id.org/xapi/dod-isd/verbs/destroyed",
    DETECTED = <any>"https=//w3id.org/xapi/dod-isd/verbs/detected",
    DETERMINED = <any>"https=//w3id.org/xapi/dod-isd/verbs/determined",
    DEVELOPED = <any>"https=//w3id.org/xapi/dod-isd/verbs/developed",
    DEVISED = <any>"https=//w3id.org/xapi/dod-isd/verbs/devised",
    DIAGNOSED = <any>"https=//w3id.org/xapi/dod-isd/verbs/diagnosed",
    DIAGRAMMED = <any>"https=//w3id.org/xapi/dod-isd/verbs/diagrammed",
    DIFFERENTIATED = <any>"https=//w3id.org/xapi/dod-isd/verbs/differentiated",
    DIRECTED = <any>"https=//w3id.org/xapi/dod-isd/verbs/directed",
    DISABLED = <any>"http=//id.tincanapi.com/verb/disabled",
    DISASSEMBLED = <any>"https=//w3id.org/xapi/dod-isd/verbs/disassembled",
    DISCARDED = <any>"http=//id.tincanapi.com/verb/discarded",
    DISCONNECTED = <any>"https=//w3id.org/xapi/dod-isd/verbs/disconnected",
    DISCOVERED = <any>"https=//w3id.org/xapi/dod-isd/verbs/discovered",
    DISCRIMINATED = <any>"https=//w3id.org/xapi/dod-isd/verbs/discriminated",
    DISENGAGED = <any>"https=//w3id.org/xapi/dod-isd/verbs/disengaged",
    DISLIKED = <any>"https=//w3id.org/xapi/acrossx/verbs/disliked",
    DISMANTLED = <any>"https=//w3id.org/xapi/dod-isd/verbs/dismantled",
    DISPATCHED = <any>"https=//w3id.org/xapi/dod-isd/verbs/dispatched",
    DISPLACED = <any>"https=//w3id.org/xapi/dod-isd/verbs/displaced",
    DISPLAYED = <any>"https=//w3id.org/xapi/dod-isd/verbs/displayed",
    DISPOSED = <any>"https=//w3id.org/xapi/dod-isd/verbs/disposed",
    DISSEMINATED = <any>"https=//w3id.org/xapi/dod-isd/verbs/disseminated",
    DISTINGUISHED = <any>"https=//w3id.org/xapi/dod-isd/verbs/distinguished",
    DISTRIBUTED = <any>"https=//w3id.org/xapi/dod-isd/verbs/distributed",
    DIVIDED = <any>"https=//w3id.org/xapi/dod-isd/verbs/divided",
    DOWNLOADED = <any>"http=//id.tincanapi.com/verb/downloaded",
    DRAFTED = <any>"https=//w3id.org/xapi/dod-isd/verbs/drafted",
    DREW = <any>"https=//w3id.org/xapi/dod-isd/verbs/drew",
    DROVE = <any>"https=//w3id.org/xapi/dod-isd/verbs/drove",
    DUG = <any>"https=//w3id.org/xapi/dod-isd/verbs/dug",
    EARNED = <any>"http=//id.tincanapi.com/verb/earned",
    EDITED = <any>"https=//w3id.org/xapi/acrossx/verbs/edited",
    EFFECTED = <any>"https=//w3id.org/xapi/dod-isd/verbs/effected",
    EGRESSED = <any>"https=//w3id.org/xapi/dod-isd/verbs/egressed",
    ELABORATED = <any>"https=//w3id.org/xapi/dod-isd/verbs/elaborated",
    ELEVATED = <any>"https=//w3id.org/xapi/dod-isd/verbs/elevated",
    ELIMINATED = <any>"https=//w3id.org/xapi/dod-isd/verbs/eliminated",
    EMPLACED = <any>"https=//w3id.org/xapi/dod-isd/verbs/emplaced",
    EMPLOYED = <any>"https=//w3id.org/xapi/dod-isd/verbs/employed",
    ENABLED = <any>"http=//id.tincanapi.com/verb/enabled",
    ENCODED = <any>"https=//w3id.org/xapi/dod-isd/verbs/encoded",
    ENCRYPTED = <any>"https=//w3id.org/xapi/dod-isd/verbs/encrypted",
    ENERGIZED = <any>"https=//w3id.org/xapi/dod-isd/verbs/energized",
    ENFORCED = <any>"https=//w3id.org/xapi/dod-isd/verbs/enforced",
    ENGAGED = <any>"https=//w3id.org/xapi/dod-isd/verbs/engaged",
    ENSURED = <any>"https=//w3id.org/xapi/dod-isd/verbs/ensured",
    ENTERED = <any>"https=//w3id.org/xapi/dod-isd/verbs/entered",
    ENTEREDFRAME = <any>"http// id.tincanapi.com/verb/frame/entered",
    ESTABLISHED = <any>"https=//w3id.org/xapi/dod-isd/verbs/established",
    ESTIMATED = <any>"https=//w3id.org/xapi/dod-isd/verbs/estimated",
    ESTIMATEDDURATION = <any>"http// id.tincanapi.com/verb/estimated-duration",
    EVACUATED = <any>"https=//w3id.org/xapi/dod-isd/verbs/evacuated",
    EVADED = <any>"https=//w3id.org/xapi/dod-isd/verbs/evaded",
    EVALUATED = <any>"https=//w3id.org/xapi/acrossx/verbs/evaluated",
    EXCHANGED = <any>"https=//w3id.org/xapi/dod-isd/verbs/exchanged",
    EXECUTED = <any>"https=//w3id.org/xapi/dod-isd/verbs/executed",
    EXITED = <any>"http=//adlnet.gov/expapi/verbs/exited",
    EXITEDFRAME = <any>"http//id.tincanapi.com/verb/frame/exited",
    EXPECTED = <any>"http=//id.tincanapi.com/verb/expected",
    EXPERIENCED = <any>"http=//adlnet.gov/expapi/verbs/experienced",
    EXPIRED = <any>"http=//id.tincanapi.com/verb/expired",
    EXPLAINED = <any>"https=//w3id.org/xapi/dod-isd/verbs/explained",
    EXPRESSED = <any>"https=//w3id.org/xapi/dod-isd/verbs/expressed",
    EXTENDED = <any>"https=//w3id.org/xapi/dod-isd/verbs/extended",
    EXTRACTED = <any>"https=//w3id.org/xapi/dod-isd/verbs/extracted",
    FAILED = <any>"http=//adlnet.gov/expapi/verbs/failed",
    FELL = <any>"https=//w3id.org/xapi/dod-isd/verbs/fell",
    FELT = <any>"https=//w3id.org/xapi/dod-isd/verbs/felt",
    FILLEDOUT = <any>"https//w3id.org/xapi/dod-isd/verbs/filled-out",
    FINALIZED = <any>"https=//w3id.org/xapi/dod-isd/verbs/finalized",
    FIRED = <any>"https=//w3id.org/xapi/dod-isd/verbs/fired",
    FIT = <any>"https=//w3id.org/xapi/dod-isd/verbs/fit",
    FOCUSED = <any>"http=//id.tincanapi.com/verb/focused",
    FOLLOWED = <any>"https=//w3id.org/xapi/dod-isd/verbs/followed",
    FORMATTED = <any>"https=//w3id.org/xapi/dod-isd/verbs/formatted",
    FORMULATED = <any>"https=//w3id.org/xapi/dod-isd/verbs/formulated",
    FORWARDED = <any>"https=//w3id.org/xapi/dod-isd/verbs/forwarded",
    FOUND = <any>"https=//w3id.org/xapi/dod-isd/verbs/found",
    FUELED = <any>"https=//w3id.org/xapi/dod-isd/verbs/fueled",
    GAVE = <any>"https=//w3id.org/xapi/dod-isd/verbs/gave",
    GENERALIZED = <any>"https=//w3id.org/xapi/dod-isd/verbs/generalized",
    GENERATED = <any>"https=//w3id.org/xapi/dod-isd/verbs/generated",
    GROUNDED = <any>"https=//w3id.org/xapi/dod-isd/verbs/grounded",
    GROUPED = <any>"https=//w3id.org/xapi/dod-isd/verbs/grouped",
    GUARDED = <any>"https=//w3id.org/xapi/dod-isd/verbs/guarded",
    GUIDED = <any>"https=//w3id.org/xapi/dod-isd/verbs/guided",
    HARDENED = <any>"https=//w3id.org/xapi/dod-isd/verbs/hardened",
    HEARD = <any>"https=//w3id.org/xapi/dod-isd/verbs/heard",
    HELD = <any>"https=//w3id.org/xapi/dod-isd/verbs/held",
    HIGHLIGHTED = <any>"https=//w3id.org/xapi/adb/verbs/highlighted",
    HIRED = <any>"http=//id.tincanapi.com/verb/hired",
    HOISTED = <any>"https=//w3id.org/xapi/dod-isd/verbs/hoisted",
    HOVERED = <any>"https=//w3id.org/xapi/dod-isd/verbs/hovered",
    HYPOTHESIZED = <any>"https=//w3id.org/xapi/dod-isd/verbs/hypothesized",
    IDENTIFIED = <any>"https=//w3id.org/xapi/dod-isd/verbs/identified",
    IGNORED = <any>"https=//w3id.org/xapi/medbiq/verbs/ignored",
    ILLUSTRATED = <any>"https=//w3id.org/xapi/dod-isd/verbs/illustrated",
    IMAGINED = <any>"https=//w3id.org/xapi/dod-isd/verbs/imagined",
    IMPLEMENTED = <any>"https=//w3id.org/xapi/dod-isd/verbs/implemented",
    IMPORTED = <any>"http=//adlnet.gov/expapi/verbs/imported",
    INDICATED = <any>"https=//w3id.org/xapi/dod-isd/verbs/indicated",
    INFERRED = <any>"https=//w3id.org/xapi/dod-isd/verbs/inferred",
    INFILTRATED = <any>"https=//w3id.org/xapi/dod-isd/verbs/infiltrated",
    INFLUENCED = <any>"https=//w3id.org/xapi/dod-isd/verbs/influenced",
    INFORMED = <any>"https=//w3id.org/xapi/dod-isd/verbs/informed",
    INITIALIZED = <any>"http=//adlnet.gov/expapi/verbs/initialized",
    INITIATED = <any>"https=//w3id.org/xapi/adb/verbs/initiated",
    INNOVATED = <any>"https=//w3id.org/xapi/dod-isd/verbs/innovated",
    INPUT = <any>"https=//w3id.org/xapi/dod-isd/verbs/input",
    INSERTED = <any>"https=//w3id.org/xapi/dod-isd/verbs/inserted",
    INSPECTED = <any>"https=//w3id.org/xapi/dod-isd/verbs/inspected",
    INSTALLED = <any>"https=//w3id.org/xapi/dod-isd/verbs/installed",
    INSTRUCTED = <any>"https=//w3id.org/xapi/dod-isd/verbs/instructed",
    INTEGRATED = <any>"https=//w3id.org/xapi/dod-isd/verbs/integrated",
    INTERACTED = <any>"http=//adlnet.gov/expapi/verbs/interacted",
    INTERCEPTED = <any>"https=//w3id.org/xapi/dod-isd/verbs/intercepted",
    INTERPRETED = <any>"https=//w3id.org/xapi/dod-isd/verbs/interpreted",
    INTERVIEWED = <any>"http=//id.tincanapi.com/verb/interviewed",
    INVENTED = <any>"https=//w3id.org/xapi/dod-isd/verbs/invented",
    INVESTIGATED = <any>"https=//w3id.org/xapi/dod-isd/verbs/investigated",
    ISOLATED = <any>"https=//w3id.org/xapi/dod-isd/verbs/isolated",
    ISSUED = <any>"https=//w3id.org/xapi/dod-isd/verbs/issued",
    JACKED = <any>"https=//w3id.org/xapi/dod-isd/verbs/jacked",
    JUDGED = <any>"https=//w3id.org/xapi/dod-isd/verbs/judged",
    JUSTIFIED = <any>"https=//w3id.org/xapi/dod-isd/verbs/justified",
    LABELED = <any>"https=//w3id.org/xapi/dod-isd/verbs/labeled",
    LAID = <any>"https=//w3id.org/xapi/dod-isd/verbs/laid",
    LANDED = <any>"https=//w3id.org/xapi/dod-isd/verbs/landed",
    LAUGHED = <any>"http=//id.tincanapi.com/verb/laughed",
    LAUNCHED = <any>"https=//w3id.org/xapi/dod-isd/verbs/launched",
    LED = <any>"https=//w3id.org/xapi/dod-isd/verbs/led",
    LEVELED = <any>"https=//w3id.org/xapi/dod-isd/verbs/leveled",
    LIFTED = <any>"https=//w3id.org/xapi/dod-isd/verbs/jumped",
    LIKED = <any>"https=//w3id.org/xapi/acrossx/verbs/liked",
    LISTED = <any>"https=//w3id.org/xapi/dod-isd/verbs/listed",
    LISTENED = <any>"https=//w3id.org/xapi/dod-isd/verbs/listened",
    LISTENEDATTENTIVELY = <any>"https//w3id.org/xapi/dod-isd/verbs/listened-attentively",
    LOADED = <any>"https=//w3id.org/xapi/dod-isd/verbs/loaded",
    LOCATED = <any>"https=//w3id.org/xapi/dod-isd/verbs/located",
    LOGGED = <any>"https=//w3id.org/xapi/dod-isd/verbs/logged",
    LOGGEDIN = <any>"https//w3id.org/xapi/adl/verbs/logged-in",
    LOGGEDOUT = <any>"https//w3id.org/xapi/adl/verbs/logged-out",
    LUBRICATED = <any>"https=//w3id.org/xapi/dod-isd/verbs/lubricated",
    MADE = <any>"https=//w3id.org/xapi/dod-isd/verbs/made",
    MAINTAINED = <any>"https=//w3id.org/xapi/dod-isd/verbs/maintained",
    MANAGED = <any>"https=//w3id.org/xapi/dod-isd/verbs/managed",
    MANEUVERED = <any>"https=//w3id.org/xapi/dod-isd/verbs/maneuvered",
    MANIPULATED = <any>"https=//w3id.org/xapi/dod-isd/verbs/manipulated",
    MAPPED = <any>"https=//w3id.org/xapi/dod-isd/verbs/mapped",
    MARKEDAS = <any>" http//id.tincanapi.com/verb/marked-unread",
    MASTERED = <any>"http=//adlnet.gov/expapi/verbs/mastered",
    MATCHED = <any>"https=//w3id.org/xapi/dod-isd/verbs/matched",
    MEASURED = <any>"https=//w3id.org/xapi/dod-isd/verbs/measured",
    MENTIONED = <any>"http=//id.tincanapi.com/verb/mentioned",
    MENTORED = <any>"http=//id.tincanapi.com/verb/mentored",
    MODIFIED = <any>"https=//w3id.org/xapi/dod-isd/verbs/modified",
    MODIFIEDANNOTATION = <any>"http//risc-inc.com/annotator/verbs/modified",
    MONITORED = <any>"https=//w3id.org/xapi/dod-isd/verbs/monitored",
    MOUNTED = <any>"https=//w3id.org/xapi/dod-isd/verbs/mounted",
    MOVED = <any>"https=//w3id.org/xapi/dod-isd/verbs/moved",
    NAMED = <any>"https=//w3id.org/xapi/dod-isd/verbs/named",
    NAVIGATED = <any>"https=//w3id.org/xapi/dod-isd/verbs/navigated",
    NEUTRALIZED = <any>"https=//w3id.org/xapi/dod-isd/verbs/neutralized",
    NOTED = <any>"https=//w3id.org/xapi/adb/verbs/noted",
    NOTIFIED = <any>"https=//w3id.org/xapi/dod-isd/verbs/notified",
    OBEYEDRULES = <any>"https//w3id.org/xapi/dod-isd/verbs/obeyed-rules",
    OBSERVED = <any>"https=//w3id.org/xapi/dod-isd/verbs/observed",
    OBTAINED = <any>"https=//w3id.org/xapi/dod-isd/verbs/obtained",
    OCCUPIED = <any>"https=//w3id.org/xapi/dod-isd/verbs/occupied",
    OPENED = <any>"https=//w3id.org/xapi/dod-isd/verbs/opened",
    OPERATED = <any>"https=//w3id.org/xapi/dod-isd/verbs/operated",
    ORDERED = <any>"https=//w3id.org/xapi/dod-isd/verbs/ordered",
    ORGANIZED = <any>"https=//w3id.org/xapi/dod-isd/verbs/organized",
    ORIENTED = <any>"https=//w3id.org/xapi/dod-isd/verbs/oriented",
    ORIGINATED = <any>"https=//w3id.org/xapi/dod-isd/verbs/originated",
    OUTLINED = <any>"https=//w3id.org/xapi/dod-isd/verbs/outlined",
    PACKED = <any>"https=//w3id.org/xapi/dod-isd/verbs/packed",
    PARKED = <any>"https=//w3id.org/xapi/dod-isd/verbs/parked",
    PASSED = <any>"http=//adlnet.gov/expapi/verbs/passed",
    PATROLLED = <any>"https=//w3id.org/xapi/dod-isd/verbs/patrolled",
    PAUSED = <any>"http=//id.tincanapi.com/verb/paused",
    PERCEIVED = <any>"https=//w3id.org/xapi/dod-isd/verbs/perceived",
    PERFORMED = <any>"https=//w3id.org/xapi/dod-isd/verbs/performed",
    PERFORMEDOFFLINE = <any>" http//id.tincanapi.com/verb/performed-offline",
    PERSONALIZED = <any>"http=//id.tincanapi.com/verb/personalized",
    PLACED = <any>"https=//w3id.org/xapi/dod-isd/verbs/placed",
    PLANNED = <any>"https=//w3id.org/xapi/dod-isd/verbs/planned",
    PLAYED = <any>"https=//w3id.org/xapi/video/verbs/played",
    PLOTTED = <any>"https=//w3id.org/xapi/dod-isd/verbs/plotted",
    POLICED = <any>"https=//w3id.org/xapi/dod-isd/verbs/policed",
    POSITIONED = <any>"https=//w3id.org/xapi/dod-isd/verbs/positioned",
    POSTED = <any>"https=//w3id.org/xapi/acrossx/verbs/posted",
    PREDICTED = <any>"https=//w3id.org/xapi/dod-isd/verbs/predicted",
    PREFERRED = <any>"http=//adlnet.gov/expapi/verbs/preferred",
    PREPARED = <any>"https=//w3id.org/xapi/dod-isd/verbs/prepared",
    PRESCRIBED = <any>"https=//w3id.org/xapi/dod-isd/verbs/prescribed",
    PRESSED = <any>"https=//w3id.org/xapi/seriousgames/verbs/pressed",
    PRESSURIZED = <any>"https=//w3id.org/xapi/dod-isd/verbs/pressurized",
    PREVENTED = <any>"https=//w3id.org/xapi/dod-isd/verbs/prevented",
    PREVIEWED = <any>"http=//id.tincanapi.com/verb/previewed",
    PRIMED = <any>"https=//w3id.org/xapi/dod-isd/verbs/primed",
    PRIORITIZED = <any>"https=//w3id.org/xapi/dod-isd/verbs/prioritized",
    PROCESSED = <any>"https=//w3id.org/xapi/dod-isd/verbs/processed",
    PROCURED = <any>"https=//w3id.org/xapi/dod-isd/verbs/procured",
    PRODUCED = <any>"https=//w3id.org/xapi/dod-isd/verbs/produced",
    PROGRAMMED = <any>"https=//w3id.org/xapi/dod-isd/verbs/programmed",
    PROGRESSED = <any>"http=//adlnet.gov/expapi/verbs/progressed",
    PROJECTED = <any>"https=//w3id.org/xapi/dod-isd/verbs/projected",
    PROMOTED = <any>"http=//id.tincanapi.com/verb/promoted",
    PROPOSED = <any>"https=//w3id.org/xapi/dod-isd/verbs/proposed",
    PROTECTED = <any>"https=//w3id.org/xapi/dod-isd/verbs/protected",
    PROVIDED = <any>"https=//w3id.org/xapi/dod-isd/verbs/provided",
    PUBLISHED = <any>"https=//w3id.org/xapi/dod-isd/verbs/published",
    PULLED = <any>"https=//w3id.org/xapi/dod-isd/verbs/pulled",
    QUALIFIED = <any>"https=//w3id.org/xapi/dod-isd/verbs/qualified",
    QUEUED = <any>"https=//w3id.org/xapi/dod-isd/verbs/queued",
    RAISED = <any>"https=//w3id.org/xapi/dod-isd/verbs/raised",
    RAN = <any>"https=//w3id.org/xapi/dod-isd/verbs/ran",
    RANGED = <any>"https=//w3id.org/xapi/dod-isd/verbs/ranged",
    RANKED = <any>"https=//w3id.org/xapi/dod-isd/verbs/ranked",
    RATED = <any>"http=//id.tincanapi.com/verb/rated",
    REACHED = <any>"https=//w3id.org/xapi/dod-isd/verbs/reached",
    REACTED = <any>"https=//w3id.org/xapi/dod-isd/verbs/reacted",
    READ = <any>"https=//w3id.org/xapi/dod-isd/verbs/read",
    READIED = <any>"https=//w3id.org/xapi/dod-isd/verbs/readied",
    REALIGNED = <any>"https=//w3id.org/xapi/dod-isd/verbs/realigned",
    REASSESSED = <any>"https=//w3id.org/xapi/dod-isd/verbs/reassessed",
    RECALLED = <any>"https=//w3id.org/xapi/dod-isd/verbs/recalled",
    RECEIVED = <any>"https=//w3id.org/xapi/dod-isd/verbs/received",
    RECOGNIZED = <any>"https=//w3id.org/xapi/dod-isd/verbs/recognized",
    RECOMMENDED = <any>"https=//w3id.org/xapi/dod-isd/verbs/recommended",
    RECONCILED = <any>"https=//w3id.org/xapi/dod-isd/verbs/reconciled",
    RECONNOITERED = <any>"https=//w3id.org/xapi/dod-isd/verbs/reconnoitered",
    RECORDED = <any>"https=//w3id.org/xapi/dod-isd/verbs/recorded",
    RECOUNTED = <any>"https=//w3id.org/xapi/dod-isd/verbs/recounted",
    RECOVERED = <any>"https=//w3id.org/xapi/dod-isd/verbs/recovered",
    REDISTRIBUTED = <any>"https=//w3id.org/xapi/dod-isd/verbs/redistributed",
    REDUCED = <any>"https=//w3id.org/xapi/dod-isd/verbs/reduced",
    REESTABLISHED = <any>"https=//w3id.org/xapi/dod-isd/verbs/reestablished",
    REEXAMINED = <any>"https=//w3id.org/xapi/dod-isd/verbs/reexamined",
    REFERENCED = <any>"https=//w3id.org/xapi/adb/verbs/referenced",
    REFUELED = <any>"https=//w3id.org/xapi/dod-isd/verbs/refueled",
    REGISTERED = <any>"http=//adlnet.gov/expapi/verbs/registered",
    REGULATED = <any>"https=//w3id.org/xapi/dod-isd/verbs/regulated",
    RELEASED = <any>"https=//w3id.org/xapi/seriousgames/verbs/released",
    RELIEVED = <any>"https=//w3id.org/xapi/dod-isd/verbs/relieved",
    RELOCATED = <any>"https=//w3id.org/xapi/dod-isd/verbs/relocated",
    REMOVED = <any>"https=//w3id.org/xapi/dod-isd/verbs/removed",
    REORGANIZED = <any>"https=//w3id.org/xapi/dod-isd/verbs/reorganized",
    REPAIRED = <any>"https=//w3id.org/xapi/dod-isd/verbs/repaired",
    REPLACED = <any>"https=//w3id.org/xapi/dod-isd/verbs/replaced",
    REPLENISHED = <any>"https=//w3id.org/xapi/dod-isd/verbs/replenished",
    REPLIED = <any>"http=//id.tincanapi.com/verb/replied",
    REPLIEDTO = <any>"http=//id.tincanapi.com/verb/replied-to-tweet",
    REPORTED = <any>"https=//w3id.org/xapi/acrossx/verbs/reported",
    REQUESTED = <any>"https=//w3id.org/xapi/adb/verbs/requested",
    REQUESTEDATTENTION = <any>" http//id.tincanapi.com/verb/requested-attention",
    RESET = <any>"https=//w3id.org/xapi/dod-isd/verbs/reset",
    RESOLVED = <any>"https=//w3id.org/xapi/dod-isd/verbs/resolved",
    RESPONDED = <any>"http=//adlnet.gov/expapi/verbs/responded",
    RESTATED = <any>"https=//w3id.org/xapi/dod-isd/verbs/restated",
    RESUMED = <any>"http=//adlnet.gov/expapi/verbs/resumed",
    RETRIEVED = <any>"https=//w3id.org/xapi/dod-isd/verbs/retrieved",
    RETURNED = <any>"https=//w3id.org/xapi/dod-isd/verbs/returned",
    RETWEETED = <any>"http=//id.tincanapi.com/verb/retweeted",
    REVEALED = <any>"https=//w3id.org/xapi/acrossx/verbs/revealed",
    REVIEWED = <any>"http=//id.tincanapi.com/verb/reviewed",
    REVISED = <any>"https=//w3id.org/xapi/dod-isd/verbs/revised",
    ROTATED = <any>"https=//w3id.org/xapi/dod-isd/verbs/rotated",
    ROUTED = <any>"https=//w3id.org/xapi/dod-isd/verbs/routed",
    SATISFIED = <any>"https=//w3id.org/xapi/adl/verbs/satisfied",
    SAVED = <any>"https=//w3id.org/xapi/dod-isd/verbs/saved",
    SAW = <any>"https=//w3id.org/xapi/dod-isd/verbs/saw",
    SCANNED = <any>"https=//w3id.org/xapi/dod-isd/verbs/scanned",
    SCHEDULED = <any>"https=//w3id.org/xapi/dod-isd/verbs/scheduled",
    SCORED = <any>"http=//adlnet.gov/expapi/verbs/scored",
    SEARCHED = <any>"https=//w3id.org/xapi/acrossx/verbs/searched",
    SECURED = <any>"http=//id.tincanapi.com/verb/secured",
    SEEKED = <any>"https=//w3id.org/xapi/video/verbs/seeked",
    SELECTED = <any>"http=//id.tincanapi.com/verb/selected",
    SENT = <any>"https=//w3id.org/xapi/dod-isd/verbs/sent",
    SEPARATED = <any>"https=//w3id.org/xapi/dod-isd/verbs/separated",
    SERVED = <any>"https=//w3id.org/xapi/dod-isd/verbs/served",
    SERVICED = <any>"https=//w3id.org/xapi/dod-isd/verbs/serviced",
    SET = <any>"https=//w3id.org/xapi/dod-isd/verbs/set",
    SETUP = <any>"https//w3id.org/xapi/dod-isd/verbs/set-up",
    SHARED = <any>"http=//adlnet.gov/expapi/verbs/shared",
    SHOWED = <any>"https=//w3id.org/xapi/dod-isd/verbs/showed",
    SHOWEDAWARENESS = <any>"https//w3id.org/xapi/dod-isd/verbs/showed-awareness",
    SHOWEDSENSITIVITY = <any>"https//w3id.org/xapi/dod-isd/verbs/showed-sensitivity",
    SHUTDOWN = <any>"https//w3id.org/xapi/dod-isd/verbs/shut-down",
    SIGHTED = <any>"https=//w3id.org/xapi/dod-isd/verbs/sighted",
    SIGNALED = <any>"https=//w3id.org/xapi/dod-isd/verbs/signaled",
    SKIPPED = <any>"http=//id.tincanapi.com/verb/skipped",
    SMELLED = <any>"https=//w3id.org/xapi/dod-isd/verbs/smelled",
    SOLVED = <any>"https=//w3id.org/xapi/dod-isd/verbs/solved",
    SORTED = <any>"https=//w3id.org/xapi/dod-isd/verbs/sorted",
    SPECIFIED = <any>"https=//w3id.org/xapi/dod-isd/verbs/specified",
    SPLINTED = <any>"https=//w3id.org/xapi/dod-isd/verbs/splinted",
    SQUEEZED = <any>"https=//w3id.org/xapi/dod-isd/verbs/squeezed",
    STARTED = <any>"https=//w3id.org/xapi/dod-isd/verbs/started",
    STATED = <any>"https=//w3id.org/xapi/dod-isd/verbs/stated",
    STAYED = <any>"https=//w3id.org/xapi/dod-isd/verbs/stayed",
    STEERED = <any>"https=//w3id.org/xapi/dod-isd/verbs/steered",
    STOCKPILED = <any>"https=//w3id.org/xapi/dod-isd/verbs/stockpiled",
    STOODTO = <any>"https//w3id.org/xapi/dod-isd/verbs/stood-to",
    STOPPED = <any>"https=//w3id.org/xapi/dod-isd/verbs/stopped",
    STORED = <any>"https=//w3id.org/xapi/dod-isd/verbs/stored",
    STOWED = <any>"https=//w3id.org/xapi/dod-isd/verbs/stowed",
    STRUCK = <any>"https=//w3id.org/xapi/dod-isd/verbs/struck",
    STUDIED = <any>"https=//w3id.org/xapi/dod-isd/verbs/studied",
    SUBMITTED = <any>"https=//w3id.org/xapi/dod-isd/verbs/submitted",
    SUMMARIZED = <any>"https=//w3id.org/xapi/dod-isd/verbs/summarized",
    SUPERVISED = <any>"https=//w3id.org/xapi/dod-isd/verbs/supervised",
    SUPPORTED = <any>"https=//w3id.org/xapi/dod-isd/verbs/supported",
    SUPPRESSED = <any>"https=//w3id.org/xapi/dod-isd/verbs/suppressed",
    SUSPENDED = <any>"http=//adlnet.gov/expapi/verbs/suspended",
    SWAM = <any>"https=//w3id.org/xapi/dod-isd/verbs/swam",
    SWEPT = <any>"https=//w3id.org/xapi/dod-isd/verbs/swept",
    SYNTHESIZED = <any>"https=//w3id.org/xapi/dod-isd/verbs/synthesized",
    TAILORED = <any>"https=//w3id.org/xapi/dod-isd/verbs/tailored",
    TALKEDWITH = <any>"http=//id.tincanapi.com/verb/talked-with",
    TAPPED = <any>"https=//w3id.org/xapi/dod-isd/verbs/tapped",
    TASKED = <any>"https=//w3id.org/xapi/dod-isd/verbs/tasked",
    TASTED = <any>"https=//w3id.org/xapi/dod-isd/verbs/tasted",
    TEMPERED = <any>"https=//w3id.org/xapi/dod-isd/verbs/tempered",
    TEMPLATED = <any>"https=//w3id.org/xapi/dod-isd/verbs/templated",
    TERMINATED = <any>"http=//adlnet.gov/expapi/verbs/terminated",
    TESTED = <any>"https=//w3id.org/xapi/dod-isd/verbs/tested",
    THREW = <any>"https=//w3id.org/xapi/dod-isd/verbs/threw",
    TIGHTENED = <any>"https=//w3id.org/xapi/dod-isd/verbs/tightened",
    TOLD = <any>"https=//w3id.org/xapi/dod-isd/verbs/told",
    TOOK = <any>"https=//w3id.org/xapi/dod-isd/verbs/took",
    TOOKCHARGE = <any>"https//w3id.org/xapi/dod-isd/verbs/took-charge",
    TOOKOFF = <any>"https//w3id.org/xapi/dod-isd/verbs/took-off",
    TRACED = <any>"https=//w3id.org/xapi/dod-isd/verbs/traced",
    TRACKED = <any>"https=//w3id.org/xapi/dod-isd/verbs/tracked",
    TRAINED = <any>"https=//w3id.org/xapi/dod-isd/verbs/trained",
    TRANSFERRED = <any>"https=//w3id.org/xapi/dod-isd/verbs/transferred",
    TRANSLATED = <any>"https=//w3id.org/xapi/dod-isd/verbs/translated",
    TRANSMITTED = <any>"https=//w3id.org/xapi/dod-isd/verbs/transmitted",
    TRANSPORTED = <any>"https=//w3id.org/xapi/dod-isd/verbs/transported",
    TRAVERSED = <any>"https=//w3id.org/xapi/dod-isd/verbs/traversed",
    TREATED = <any>"https=//w3id.org/xapi/dod-isd/verbs/treated",
    TRIAGED = <any>"https=//w3id.org/xapi/dod-isd/verbs/triaged",
    TROUBLESHOT = <any>"https=//w3id.org/xapi/dod-isd/verbs/troubleshot",
    TUNED = <any>"https=//w3id.org/xapi/dod-isd/verbs/tuned",
    TURNED = <any>"https=//w3id.org/xapi/dod-isd/verbs/turned",
    TWEETED = <any>"http=//id.tincanapi.com/verb/tweeted",
    TWISTED = <any>"https=//w3id.org/xapi/dod-isd/verbs/twisted",
    TYPED = <any>"https=//w3id.org/xapi/dod-isd/verbs/typed",
    UNFOCUSED = <any>"http=//id.tincanapi.com/verb/unfocused",
    UNLOADED = <any>"https=//w3id.org/xapi/dod-isd/verbs/unloaded",
    UNLOCKED = <any>"https=//w3id.org/xapi/seriousgames/verbs/unlocked",
    UNREGISTERED = <any>"http=//id.tincanapi.com/verb/unregistered",
    UPDATED = <any>"https=//w3id.org/xapi/medbiq/verbs/updated",
    USED = <any>"https=//w3id.org/xapi/seriousgames/verbs/used",
    UTILIZED = <any>"https=//w3id.org/xapi/dod-isd/verbs/utilized",
    VALIDATED = <any>"https=//w3id.org/xapi/dod-isd/verbs/validated",
    VERIFIED = <any>"https=//w3id.org/xapi/dod-isd/verbs/verified",
    VIEWED = <any>"http=//id.tincanapi.com/verb/viewed",
    VISUALIZED = <any>"https=//w3id.org/xapi/dod-isd/verbs/visualized",
    VOIDED = <any>"http=//adlnet.gov/expapi/verbs/voided",
    VOTEDDOWN = <any>"http//id.tincanapi.com/verb/voted-down",
    VOTEDUP = <any>"http//id.tincanapi.com/verb/voted-up",
    WAITED = <any>"https=//w3id.org/xapi/dod-isd/verbs/waited",
    WAIVED = <any>"https=//w3id.org/xapi/adl/verbs/waived",
    WARGAMED = <any>"https//w3id.org/xapi/dod-isd/verbs/war-gamed",
    WASASSIGNED = <any>"https//w3id.org/xapi/acrossx/verbs/was-assigned",
    WATCHED = <any>"https=//w3id.org/xapi/acrossx/verbs/watched",
    WORE = <any>"https=//w3id.org/xapi/dod-isd/verbs/wore",
    WROTE = <any>"https=//w3id.org/xapi/dod-isd/verbs/wrote",
    ZEROED = <any>"https=//w3id.org/xapi/dod-isd/verbs/zeroed",
}

// export type VerbIds<IVerbIds> = {
//     readonly [P in keyof IVerbIds]: IVerbIds[P];
// };

export type VerbIds1 =
    "https=//w3id.org/xapi/adl/verbs/abandoned" |
    "https=//w3id.org/xapi/dod-isd/verbs/abled" |
    "https=//w3id.org/xapi/seriousgames/verbs/accessed" |
    "https=//w3id.org/xapi/dod-isd/verbs/acclimatized" |
    "https=//w3id.org/xapi/dod-isd/verbs/accommodated" |
    "https=//w3id.org/xapi/dod-isd/verbs/accomplished" |
    "https=//w3id.org/xapi/dod-isd/verbs/achieved" |
    "https=//w3id.org/xapi/dod-isd/verbs/acknowledged" |
    "https=//w3id.org/xapi/dod-isd/verbs/activated" |
    "https=//w3id.org/xapi/dod-isd/verbs/actuated" |
    "https=//w3id.org/xapi/dod-isd/verbs/adapted" |
    "http=//id.tincanapi.com/verb/adjourned" |
    "https=//w3id.org/xapi/dod-isd/verbs/adjusted" |
    "https=//w3id.org/xapi/dod-isd/verbs/administered" |
    "https=//w3id.org/xapi/dod-isd/verbs/advanced" |
    "https=//w3id.org/xapi/dod-isd/verbs/advised" |
    "https=//w3id.org/xapi/dod-isd/verbs/alerted" |
    "https=//w3id.org/xapi/dod-isd/verbs/aligned" |
    "https=//w3id.org/xapi/dod-isd/verbs/allocated" |
    "https=//w3id.org/xapi/dod-isd/verbs/allowed" |
    "https=//w3id.org/xapi/dod-isd/verbs/altered" |
    "https=//w3id.org/xapi/dod-isd/verbs/ambushed" |
    "https=//w3id.org/xapi/dod-isd/verbs/analyzed" |
    "http=//risc-inc.com/annotator/verbs/annotated" |
    "https=//w3id.org/xapi/dod-isd/verbs/announced" |
    "http=//adlnet.gov/expapi/verbs/answered" |
    "http=//id.tincanapi.com/verb/applauded" |
    "https=//w3id.org/xapi/dod-isd/verbs/applied" |
    "https=//w3id.org/xapi/dod-isd/verbs/appraised" |
    "https=//w3id.org/xapi/dod-isd/verbs/appreciated" |
    "https=//w3id.org/xapi/dod-isd/verbs/approved" |
    "https=//w3id.org/xapi/dod-isd/verbs/archived" |
    "https=//w3id.org/xapi/dod-isd/verbs/armed" |
    "http=//id.tincanapi.com/verb/arranged" |
    "https=//w3id.org/xapi/adb/verbs/arrived" |
    "http=//adlnet.gov/expapi/verbs/asked" |
    "https=//w3id.org/xapi/dod-isd/verbs/assaulted" |
    "https=//w3id.org/xapi/dod-isd/verbs/assembled" |
    "https=//w3id.org/xapi/dod-isd/verbs/assessed" |
    "https=//w3id.org/xapi/dod-isd/verbs/assigned" |
    "https=//w3id.org/xapi/dod-isd/verbs/assisted" |
    "https=//w3id.org/xapi/dod-isd/verbs/assumed" |
    "https=//w3id.org/xapi/dod-isd/verbs/attached" |
    "https=//w3id.org/xapi/dod-isd/verbs/attacked" |
    "http=//adlnet.gov/expapi/verbs/attempted" |
    "https=//w3id.org/xapi/adb/verbs/attended" |
    "https//w3id.org/xapi/dod-isd/verbs/attended-closely" |
    "https=//w3id.org/xapi/dod-isd/verbs/authenticated" |
    "https=//w3id.org/xapi/dod-isd/verbs/balanced" |
    "https=//w3id.org/xapi/dod-isd/verbs/believed" |
    "http=//id.tincanapi.com/verb/bookmarked" |
    "https=//w3id.org/xapi/dod-isd/verbs/breached" |
    "https=//w3id.org/xapi/dod-isd/verbs/briefed" |
    "https=//w3id.org/xapi/dod-isd/verbs/bypassed" |
    "https=//w3id.org/xapi/dod-isd/verbs/calculated" |
    "https=//w3id.org/xapi/dod-isd/verbs/calibrated" |
    "http=//id.tincanapi.com/verb/called" |
    "https=//w3id.org/xapi/dod-isd/verbs/camouflaged" |
    "https=//w3id.org/xapi/dod-isd/verbs/canceled" |
    "https=//w3id.org/xapi/dod-isd/verbs/carried" |
    "https=//w3id.org/xapi/dod-isd/verbs/categorized" |
    "https=//w3id.org/xapi/dod-isd/verbs/caused" |
    "https=//w3id.org/xapi/dod-isd/verbs/centered" |
    "https=//w3id.org/xapi/dod-isd/verbs/challenged" |
    "https=//w3id.org/xapi/dod-isd/verbs/changed" |
    "https=//w3id.org/xapi/dod-isd/verbs/charged" |
    "https=//w3id.org/xapi/dod-isd/verbs/checked" |
    "https=//w3id.org/xapi/dod-isd/verbs/chose" |
    "https=//w3id.org/xapi/dod-isd/verbs/classified" |
    "https=//w3id.org/xapi/dod-isd/verbs/cleaned" |
    "https=//w3id.org/xapi/dod-isd/verbs/cleared" |
    "https=//w3id.org/xapi/dod-isd/verbs/closed" |
    "http//id.tincanapi.com/verb/closed-sale" |
    "https=//w3id.org/xapi/adb/verbs/coached" |
    "https=//w3id.org/xapi/dod-isd/verbs/collated" |
    "https=//w3id.org/xapi/dod-isd/verbs/collected" |
    "https=//w3id.org/xapi/dod-isd/verbs/combined" |
    "https=//w3id.org/xapi/dod-isd/verbs/commanded" |
    "http=//adlnet.gov/expapi/verbs/commented" |
    "https=//w3id.org/xapi/dod-isd/verbs/communicated" |
    "https=//w3id.org/xapi/dod-isd/verbs/compared" |
    "https=//w3id.org/xapi/dod-isd/verbs/compiled" |
    "http=//adlnet.gov/expapi/verbs/completed" |
    "https//w3id.org/xapi/dod-isd/verbs/completed-assignment" |
    "https=//w3id.org/xapi/dod-isd/verbs/complied" |
    "https=//w3id.org/xapi/dod-isd/verbs/composed" |
    "https=//w3id.org/xapi/dod-isd/verbs/computed" |
    "https=//w3id.org/xapi/dod-isd/verbs/conceived" |
    "https=//w3id.org/xapi/dod-isd/verbs/concluded" |
    "https=//w3id.org/xapi/dod-isd/verbs/condensed" |
    "https=//w3id.org/xapi/dod-isd/verbs/conducted" |
    "https=//w3id.org/xapi/dod-isd/verbs/confirmed" |
    "https=//w3id.org/xapi/dod-isd/verbs/conjectured" |
    "https=//w3id.org/xapi/dod-isd/verbs/connected" |
    "https=//w3id.org/xapi/dod-isd/verbs/consolidated" |
    "https=//w3id.org/xapi/dod-isd/verbs/constructed" |
    "https=//w3id.org/xapi/dod-isd/verbs/contrasted" |
    "https=//w3id.org/xapi/dod-isd/verbs/contrived" |
    "https=//w3id.org/xapi/dod-isd/verbs/controlled" |
    "https=//w3id.org/xapi/dod-isd/verbs/converted" |
    "https=//w3id.org/xapi/dod-isd/verbs/coordinated" |
    "https=//w3id.org/xapi/dod-isd/verbs/corrected" |
    "https=//w3id.org/xapi/dod-isd/verbs/correlated" |
    "https=//w3id.org/xapi/dod-isd/verbs/covered" |
    "https=//w3id.org/xapi/dod-isd/verbs/created" |
    "http//id.tincanapi.com/verb/created-opportunity" |
    "https=//w3id.org/xapi/dod-isd/verbs/crept" |
    "https=//w3id.org/xapi/dod-isd/verbs/criticized" |
    "https//w3id.org/xapi/dod-isd/verbs/cross-checked" |
    "https=//w3id.org/xapi/dod-isd/verbs/crossed" |
    "https=//w3id.org/xapi/dod-isd/verbs/debriefed" |
    "https=//w3id.org/xapi/dod-isd/verbs/debugged" |
    "https=//w3id.org/xapi/dod-isd/verbs/decided" |
    "https=//w3id.org/xapi/dod-isd/verbs/decontaminated" |
    "https=//w3id.org/xapi/dod-isd/verbs/defended" |
    "http=//id.tincanapi.com/verb/defined" |
    "https=//w3id.org/xapi/dod-isd/verbs/delayed" |
    "https=//w3id.org/xapi/dod-isd/verbs/deleted" |
    "https=//w3id.org/xapi/dod-isd/verbs/delivered" |
    "https=//w3id.org/xapi/adb/verbs/demanded" |
    "https=//w3id.org/xapi/dod-isd/verbs/demonstrated" |
    "https=//w3id.org/xapi/dod-isd/verbs/departed" |
    "https=//w3id.org/xapi/dod-isd/verbs/deployed" |
    "https=//w3id.org/xapi/dod-isd/verbs/derived" |
    "https=//w3id.org/xapi/adb/verbs/described" |
    "https=//w3id.org/xapi/dod-isd/verbs/designated" |
    "https=//w3id.org/xapi/acrossx/verbs/designed" |
    "https=//w3id.org/xapi/dod-isd/verbs/destroyed" |
    "https=//w3id.org/xapi/dod-isd/verbs/detected" |
    "https=//w3id.org/xapi/dod-isd/verbs/determined" |
    "https=//w3id.org/xapi/dod-isd/verbs/developed" |
    "https=//w3id.org/xapi/dod-isd/verbs/devised" |
    "https=//w3id.org/xapi/dod-isd/verbs/diagnosed" |
    "https=//w3id.org/xapi/dod-isd/verbs/diagrammed" |
    "https=//w3id.org/xapi/dod-isd/verbs/differentiated" |
    "https=//w3id.org/xapi/dod-isd/verbs/directed" |
    "http=//id.tincanapi.com/verb/disabled" |
    "https=//w3id.org/xapi/dod-isd/verbs/disassembled" |
    "http=//id.tincanapi.com/verb/discarded" |
    "https=//w3id.org/xapi/dod-isd/verbs/disconnected" |
    "https=//w3id.org/xapi/dod-isd/verbs/discovered" |
    "https=//w3id.org/xapi/dod-isd/verbs/discriminated" |
    "https=//w3id.org/xapi/dod-isd/verbs/disengaged" |
    "https=//w3id.org/xapi/acrossx/verbs/disliked" |
    "https=//w3id.org/xapi/dod-isd/verbs/dismantled" |
    "https=//w3id.org/xapi/dod-isd/verbs/dispatched" |
    "https=//w3id.org/xapi/dod-isd/verbs/displaced" |
    "https=//w3id.org/xapi/dod-isd/verbs/displayed" |
    "https=//w3id.org/xapi/dod-isd/verbs/disposed" |
    "https=//w3id.org/xapi/dod-isd/verbs/disseminated" |
    "https=//w3id.org/xapi/dod-isd/verbs/distinguished" |
    "https=//w3id.org/xapi/dod-isd/verbs/distributed" |
    "https=//w3id.org/xapi/dod-isd/verbs/divided" |
    "http=//id.tincanapi.com/verb/downloaded" |
    "https=//w3id.org/xapi/dod-isd/verbs/drafted" |
    "https=//w3id.org/xapi/dod-isd/verbs/drew" |
    "https=//w3id.org/xapi/dod-isd/verbs/drove" |
    "https=//w3id.org/xapi/dod-isd/verbs/dug" |
    "http=//id.tincanapi.com/verb/earned" |
    "https=//w3id.org/xapi/acrossx/verbs/edited" |
    "https=//w3id.org/xapi/dod-isd/verbs/effected" |
    "https=//w3id.org/xapi/dod-isd/verbs/egressed" |
    "https=//w3id.org/xapi/dod-isd/verbs/elaborated" |
    "https=//w3id.org/xapi/dod-isd/verbs/elevated" |
    "https=//w3id.org/xapi/dod-isd/verbs/eliminated" |
    "https=//w3id.org/xapi/dod-isd/verbs/emplaced" |
    "https=//w3id.org/xapi/dod-isd/verbs/employed" |
    "http=//id.tincanapi.com/verb/enabled" |
    "https=//w3id.org/xapi/dod-isd/verbs/encoded" |
    "https=//w3id.org/xapi/dod-isd/verbs/encrypted" |
    "https=//w3id.org/xapi/dod-isd/verbs/energized" |
    "https=//w3id.org/xapi/dod-isd/verbs/enforced" |
    "https=//w3id.org/xapi/dod-isd/verbs/engaged" |
    "https=//w3id.org/xapi/dod-isd/verbs/ensured" |
    "https=//w3id.org/xapi/dod-isd/verbs/entered" |
    "http// id.tincanapi.com/verb/frame/entered" |
    "https=//w3id.org/xapi/dod-isd/verbs/established" |
    "https=//w3id.org/xapi/dod-isd/verbs/estimated" |
    "http// id.tincanapi.com/verb/estimated-duration" |
    "https=//w3id.org/xapi/dod-isd/verbs/evacuated" |
    "https=//w3id.org/xapi/dod-isd/verbs/evaded" |
    "https=//w3id.org/xapi/acrossx/verbs/evaluated" |
    "https=//w3id.org/xapi/dod-isd/verbs/exchanged" |
    "https=//w3id.org/xapi/dod-isd/verbs/executed" |
    "http=//adlnet.gov/expapi/verbs/exited" |
    "http//id.tincanapi.com/verb/frame/exited" |
    "http=//id.tincanapi.com/verb/expected" |
    "http=//adlnet.gov/expapi/verbs/experienced" |
    "http=//id.tincanapi.com/verb/expired" |
    "https=//w3id.org/xapi/dod-isd/verbs/explained" |
    "https=//w3id.org/xapi/dod-isd/verbs/expressed" |
    "https=//w3id.org/xapi/dod-isd/verbs/extended" |
    "https=//w3id.org/xapi/dod-isd/verbs/extracted" |
    "http=//adlnet.gov/expapi/verbs/failed" |
    "https=//w3id.org/xapi/dod-isd/verbs/fell" |
    "https=//w3id.org/xapi/dod-isd/verbs/felt" |
    "https//w3id.org/xapi/dod-isd/verbs/filled-out" |
    "https=//w3id.org/xapi/dod-isd/verbs/finalized" |
    "https=//w3id.org/xapi/dod-isd/verbs/fired" |
    "https=//w3id.org/xapi/dod-isd/verbs/fit" |
    "http=//id.tincanapi.com/verb/focused" |
    "https=//w3id.org/xapi/dod-isd/verbs/followed" |
    "https=//w3id.org/xapi/dod-isd/verbs/formatted" |
    "https=//w3id.org/xapi/dod-isd/verbs/formulated" |
    "https=//w3id.org/xapi/dod-isd/verbs/forwarded" |
    "https=//w3id.org/xapi/dod-isd/verbs/found" |
    "https=//w3id.org/xapi/dod-isd/verbs/fueled" |
    "https=//w3id.org/xapi/dod-isd/verbs/gave" |
    "https=//w3id.org/xapi/dod-isd/verbs/generalized" |
    "https=//w3id.org/xapi/dod-isd/verbs/generated" |
    "https=//w3id.org/xapi/dod-isd/verbs/grounded" |
    "https=//w3id.org/xapi/dod-isd/verbs/grouped" |
    "https=//w3id.org/xapi/dod-isd/verbs/guarded" |
    "https=//w3id.org/xapi/dod-isd/verbs/guided" |
    "https=//w3id.org/xapi/dod-isd/verbs/hardened" |
    "https=//w3id.org/xapi/dod-isd/verbs/heard" |
    "https=//w3id.org/xapi/dod-isd/verbs/held" |
    "https=//w3id.org/xapi/adb/verbs/highlighted" |
    "http=//id.tincanapi.com/verb/hired" |
    "https=//w3id.org/xapi/dod-isd/verbs/hoisted" |
    "https=//w3id.org/xapi/dod-isd/verbs/hovered" |
    "https=//w3id.org/xapi/dod-isd/verbs/hypothesized" |
    "https=//w3id.org/xapi/dod-isd/verbs/identified" |
    "https=//w3id.org/xapi/medbiq/verbs/ignored" |
    "https=//w3id.org/xapi/dod-isd/verbs/illustrated" |
    "https=//w3id.org/xapi/dod-isd/verbs/imagined" |
    "https=//w3id.org/xapi/dod-isd/verbs/implemented" |
    "http=//adlnet.gov/expapi/verbs/imported" |
    "https=//w3id.org/xapi/dod-isd/verbs/indicated" |
    "https=//w3id.org/xapi/dod-isd/verbs/inferred" |
    "https=//w3id.org/xapi/dod-isd/verbs/infiltrated" |
    "https=//w3id.org/xapi/dod-isd/verbs/influenced" |
    "https=//w3id.org/xapi/dod-isd/verbs/informed" |
    "http=//adlnet.gov/expapi/verbs/initialized" |
    "https=//w3id.org/xapi/adb/verbs/initiated" |
    "https=//w3id.org/xapi/dod-isd/verbs/innovated" |
    "https=//w3id.org/xapi/dod-isd/verbs/input" |
    "https=//w3id.org/xapi/dod-isd/verbs/inserted" |
    "https=//w3id.org/xapi/dod-isd/verbs/inspected" |
    "https=//w3id.org/xapi/dod-isd/verbs/installed" |
    "https=//w3id.org/xapi/dod-isd/verbs/instructed" |
    "https=//w3id.org/xapi/dod-isd/verbs/integrated" |
    "http=//adlnet.gov/expapi/verbs/interacted" |
    "https=//w3id.org/xapi/dod-isd/verbs/intercepted" |
    "https=//w3id.org/xapi/dod-isd/verbs/interpreted" |
    "http=//id.tincanapi.com/verb/interviewed" |
    "https=//w3id.org/xapi/dod-isd/verbs/invented" |
    "https=//w3id.org/xapi/dod-isd/verbs/investigated" |
    "https=//w3id.org/xapi/dod-isd/verbs/isolated" |
    "https=//w3id.org/xapi/dod-isd/verbs/issued" |
    "https=//w3id.org/xapi/dod-isd/verbs/jacked" |
    "https=//w3id.org/xapi/dod-isd/verbs/judged" |
    "https=//w3id.org/xapi/dod-isd/verbs/justified" |
    "https=//w3id.org/xapi/dod-isd/verbs/labeled" |
    "https=//w3id.org/xapi/dod-isd/verbs/laid" |
    "https=//w3id.org/xapi/dod-isd/verbs/landed" |
    "http=//id.tincanapi.com/verb/laughed" |
    "https=//w3id.org/xapi/dod-isd/verbs/launched" |
    "https=//w3id.org/xapi/dod-isd/verbs/led" |
    "https=//w3id.org/xapi/dod-isd/verbs/leveled" |
    "https=//w3id.org/xapi/dod-isd/verbs/jumped" |
    "https=//w3id.org/xapi/acrossx/verbs/liked" |
    "https=//w3id.org/xapi/dod-isd/verbs/listed" |
    "https=//w3id.org/xapi/dod-isd/verbs/listened" |
    "https//w3id.org/xapi/dod-isd/verbs/listened-attentively" |
    "https=//w3id.org/xapi/dod-isd/verbs/loaded" |
    "https=//w3id.org/xapi/dod-isd/verbs/located" |
    "https=//w3id.org/xapi/dod-isd/verbs/logged" |
    "https//w3id.org/xapi/adl/verbs/logged-in" |
    "https//w3id.org/xapi/adl/verbs/logged-out" |
    "https=//w3id.org/xapi/dod-isd/verbs/lubricated" |
    "https=//w3id.org/xapi/dod-isd/verbs/made" |
    "https=//w3id.org/xapi/dod-isd/verbs/maintained" |
    "https=//w3id.org/xapi/dod-isd/verbs/managed" |
    "https=//w3id.org/xapi/dod-isd/verbs/maneuvered" |
    "https=//w3id.org/xapi/dod-isd/verbs/manipulated" |
    "https=//w3id.org/xapi/dod-isd/verbs/mapped" |
    " http//id.tincanapi.com/verb/marked-unread" |
    "http=//adlnet.gov/expapi/verbs/mastered" |
    "https=//w3id.org/xapi/dod-isd/verbs/matched" |
    "https=//w3id.org/xapi/dod-isd/verbs/measured" |
    "http=//id.tincanapi.com/verb/mentioned" |
    "http=//id.tincanapi.com/verb/mentored" |
    "https=//w3id.org/xapi/dod-isd/verbs/modified" |
    "http//risc-inc.com/annotator/verbs/modified" |
    "https=//w3id.org/xapi/dod-isd/verbs/monitored" |
    "https=//w3id.org/xapi/dod-isd/verbs/mounted" |
    "https=//w3id.org/xapi/dod-isd/verbs/moved" |
    "https=//w3id.org/xapi/dod-isd/verbs/named" |
    "https=//w3id.org/xapi/dod-isd/verbs/navigated" |
    "https=//w3id.org/xapi/dod-isd/verbs/neutralized" |
    "https=//w3id.org/xapi/adb/verbs/noted" |
    "https=//w3id.org/xapi/dod-isd/verbs/notified" |
    "https//w3id.org/xapi/dod-isd/verbs/obeyed-rules" |
    "https=//w3id.org/xapi/dod-isd/verbs/observed" |
    "https=//w3id.org/xapi/dod-isd/verbs/obtained" |
    "https=//w3id.org/xapi/dod-isd/verbs/occupied" |
    "https=//w3id.org/xapi/dod-isd/verbs/opened" |
    "https=//w3id.org/xapi/dod-isd/verbs/operated" |
    "https=//w3id.org/xapi/dod-isd/verbs/ordered" |
    "https=//w3id.org/xapi/dod-isd/verbs/organized" |
    "https=//w3id.org/xapi/dod-isd/verbs/oriented" |
    "https=//w3id.org/xapi/dod-isd/verbs/originated" |
    "https=//w3id.org/xapi/dod-isd/verbs/outlined" |
    "https=//w3id.org/xapi/dod-isd/verbs/packed" |
    "https=//w3id.org/xapi/dod-isd/verbs/parked" |
    "http=//adlnet.gov/expapi/verbs/passed" |
    "https=//w3id.org/xapi/dod-isd/verbs/patrolled" |
    "http=//id.tincanapi.com/verb/paused" |
    "https=//w3id.org/xapi/dod-isd/verbs/perceived" |
    "https=//w3id.org/xapi/dod-isd/verbs/performed" |
    " http//id.tincanapi.com/verb/performed-offline" |
    "http=//id.tincanapi.com/verb/personalized" |
    "https=//w3id.org/xapi/dod-isd/verbs/placed" |
    "https=//w3id.org/xapi/dod-isd/verbs/planned" |
    "https=//w3id.org/xapi/video/verbs/played" |
    "https=//w3id.org/xapi/dod-isd/verbs/plotted" |
    "https=//w3id.org/xapi/dod-isd/verbs/policed" |
    "https=//w3id.org/xapi/dod-isd/verbs/positioned" |
    "https=//w3id.org/xapi/acrossx/verbs/posted" |
    "https=//w3id.org/xapi/dod-isd/verbs/predicted" |
    "http=//adlnet.gov/expapi/verbs/preferred" |
    "https=//w3id.org/xapi/dod-isd/verbs/prepared" |
    "https=//w3id.org/xapi/dod-isd/verbs/prescribed" |
    "https=//w3id.org/xapi/seriousgames/verbs/pressed" |
    "https=//w3id.org/xapi/dod-isd/verbs/pressurized" |
    "https=//w3id.org/xapi/dod-isd/verbs/prevented" |
    "http=//id.tincanapi.com/verb/previewed" |
    "https=//w3id.org/xapi/dod-isd/verbs/primed" |
    "https=//w3id.org/xapi/dod-isd/verbs/prioritized" |
    "https=//w3id.org/xapi/dod-isd/verbs/processed" |
    "https=//w3id.org/xapi/dod-isd/verbs/procured" |
    "https=//w3id.org/xapi/dod-isd/verbs/produced" |
    "https=//w3id.org/xapi/dod-isd/verbs/programmed" |
    "http=//adlnet.gov/expapi/verbs/progressed" |
    "https=//w3id.org/xapi/dod-isd/verbs/projected" |
    "http=//id.tincanapi.com/verb/promoted" |
    "https=//w3id.org/xapi/dod-isd/verbs/proposed" |
    "https=//w3id.org/xapi/dod-isd/verbs/protected" |
    "https=//w3id.org/xapi/dod-isd/verbs/provided" |
    "https=//w3id.org/xapi/dod-isd/verbs/published" |
    "https=//w3id.org/xapi/dod-isd/verbs/pulled" |
    "https=//w3id.org/xapi/dod-isd/verbs/qualified" |
    "https=//w3id.org/xapi/dod-isd/verbs/queued" |
    "https=//w3id.org/xapi/dod-isd/verbs/raised" |
    "https=//w3id.org/xapi/dod-isd/verbs/ran" |
    "https=//w3id.org/xapi/dod-isd/verbs/ranged" |
    "https=//w3id.org/xapi/dod-isd/verbs/ranked" |
    "http=//id.tincanapi.com/verb/rated" |
    "https=//w3id.org/xapi/dod-isd/verbs/reached" |
    "https=//w3id.org/xapi/dod-isd/verbs/reacted" |
    "https=//w3id.org/xapi/dod-isd/verbs/read" |
    "https=//w3id.org/xapi/dod-isd/verbs/readied" |
    "https=//w3id.org/xapi/dod-isd/verbs/realigned" |
    "https=//w3id.org/xapi/dod-isd/verbs/reassessed" |
    "https=//w3id.org/xapi/dod-isd/verbs/recalled" |
    "https=//w3id.org/xapi/dod-isd/verbs/received" |
    "https=//w3id.org/xapi/dod-isd/verbs/recognized" |
    "https=//w3id.org/xapi/dod-isd/verbs/recommended" |
    "https=//w3id.org/xapi/dod-isd/verbs/reconciled" |
    "https=//w3id.org/xapi/dod-isd/verbs/reconnoitered" |
    "https=//w3id.org/xapi/dod-isd/verbs/recorded" |
    "https=//w3id.org/xapi/dod-isd/verbs/recounted" |
    "https=//w3id.org/xapi/dod-isd/verbs/recovered" |
    "https=//w3id.org/xapi/dod-isd/verbs/redistributed" |
    "https=//w3id.org/xapi/dod-isd/verbs/reduced" |
    "https=//w3id.org/xapi/dod-isd/verbs/reestablished" |
    "https=//w3id.org/xapi/dod-isd/verbs/reexamined" |
    "https=//w3id.org/xapi/adb/verbs/referenced" |
    "https=//w3id.org/xapi/dod-isd/verbs/refueled" |
    "http=//adlnet.gov/expapi/verbs/registered" |
    "https=//w3id.org/xapi/dod-isd/verbs/regulated" |
    "https=//w3id.org/xapi/seriousgames/verbs/released" |
    "https=//w3id.org/xapi/dod-isd/verbs/relieved" |
    "https=//w3id.org/xapi/dod-isd/verbs/relocated" |
    "https=//w3id.org/xapi/dod-isd/verbs/removed" |
    "https=//w3id.org/xapi/dod-isd/verbs/reorganized" |
    "https=//w3id.org/xapi/dod-isd/verbs/repaired" |
    "https=//w3id.org/xapi/dod-isd/verbs/replaced" |
    "https=//w3id.org/xapi/dod-isd/verbs/replenished" |
    "http=//id.tincanapi.com/verb/replied" |
    "http=//id.tincanapi.com/verb/replied-to-tweet" |
    "https=//w3id.org/xapi/acrossx/verbs/reported" |
    "https=//w3id.org/xapi/adb/verbs/requested" |
    " http//id.tincanapi.com/verb/requested-attention" |
    "https=//w3id.org/xapi/dod-isd/verbs/reset" |
    "https=//w3id.org/xapi/dod-isd/verbs/resolved" |
    "http=//adlnet.gov/expapi/verbs/responded" |
    "https=//w3id.org/xapi/dod-isd/verbs/restated" |
    "http=//adlnet.gov/expapi/verbs/resumed" |
    "https=//w3id.org/xapi/dod-isd/verbs/retrieved" |
    "https=//w3id.org/xapi/dod-isd/verbs/returned" |
    "http=//id.tincanapi.com/verb/retweeted" |
    "https=//w3id.org/xapi/acrossx/verbs/revealed" |
    "http=//id.tincanapi.com/verb/reviewed" |
    "https=//w3id.org/xapi/dod-isd/verbs/revised" |
    "https=//w3id.org/xapi/dod-isd/verbs/rotated" |
    "https=//w3id.org/xapi/dod-isd/verbs/routed" |
    "https=//w3id.org/xapi/adl/verbs/satisfied" |
    "https=//w3id.org/xapi/dod-isd/verbs/saved" |
    "https=//w3id.org/xapi/dod-isd/verbs/saw" |
    "https=//w3id.org/xapi/dod-isd/verbs/scanned" |
    "https=//w3id.org/xapi/dod-isd/verbs/scheduled" |
    "http=//adlnet.gov/expapi/verbs/scored" |
    "https=//w3id.org/xapi/acrossx/verbs/searched" |
    "http=//id.tincanapi.com/verb/secured" |
    "https=//w3id.org/xapi/video/verbs/seeked" |
    "http=//id.tincanapi.com/verb/selected" |
    "https=//w3id.org/xapi/dod-isd/verbs/sent" |
    "https=//w3id.org/xapi/dod-isd/verbs/separated" |
    "https=//w3id.org/xapi/dod-isd/verbs/served" |
    "https=//w3id.org/xapi/dod-isd/verbs/serviced" |
    "https=//w3id.org/xapi/dod-isd/verbs/set" |
    "https//w3id.org/xapi/dod-isd/verbs/set-up" |
    "http=//adlnet.gov/expapi/verbs/shared" |
    "https=//w3id.org/xapi/dod-isd/verbs/showed" |
    "https//w3id.org/xapi/dod-isd/verbs/showed-awareness" |
    "https//w3id.org/xapi/dod-isd/verbs/showed-sensitivity" |
    "https//w3id.org/xapi/dod-isd/verbs/shut-down" |
    "https=//w3id.org/xapi/dod-isd/verbs/sighted" |
    "https=//w3id.org/xapi/dod-isd/verbs/signaled" |
    "http=//id.tincanapi.com/verb/skipped" |
    "https=//w3id.org/xapi/dod-isd/verbs/smelled" |
    "https=//w3id.org/xapi/dod-isd/verbs/solved" |
    "https=//w3id.org/xapi/dod-isd/verbs/sorted" |
    "https=//w3id.org/xapi/dod-isd/verbs/specified" |
    "https=//w3id.org/xapi/dod-isd/verbs/splinted" |
    "https=//w3id.org/xapi/dod-isd/verbs/squeezed" |
    "https=//w3id.org/xapi/dod-isd/verbs/started" |
    "https=//w3id.org/xapi/dod-isd/verbs/stated" |
    "https=//w3id.org/xapi/dod-isd/verbs/stayed" |
    "https=//w3id.org/xapi/dod-isd/verbs/steered" |
    "https=//w3id.org/xapi/dod-isd/verbs/stockpiled" |
    "https//w3id.org/xapi/dod-isd/verbs/stood-to" |
    "https=//w3id.org/xapi/dod-isd/verbs/stopped" |
    "https=//w3id.org/xapi/dod-isd/verbs/stored" |
    "https=//w3id.org/xapi/dod-isd/verbs/stowed" |
    "https=//w3id.org/xapi/dod-isd/verbs/struck" |
    "https=//w3id.org/xapi/dod-isd/verbs/studied" |
    "https=//w3id.org/xapi/dod-isd/verbs/submitted" |
    "https=//w3id.org/xapi/dod-isd/verbs/summarized" |
    "https=//w3id.org/xapi/dod-isd/verbs/supervised" |
    "https=//w3id.org/xapi/dod-isd/verbs/supported" |
    "https=//w3id.org/xapi/dod-isd/verbs/suppressed" |
    "http=//adlnet.gov/expapi/verbs/suspended" |
    "https=//w3id.org/xapi/dod-isd/verbs/swam" |
    "https=//w3id.org/xapi/dod-isd/verbs/swept" |
    "https=//w3id.org/xapi/dod-isd/verbs/synthesized" |
    "https=//w3id.org/xapi/dod-isd/verbs/tailored" |
    "http=//id.tincanapi.com/verb/talked-with" |
    "https=//w3id.org/xapi/dod-isd/verbs/tapped" |
    "https=//w3id.org/xapi/dod-isd/verbs/tasked" |
    "https=//w3id.org/xapi/dod-isd/verbs/tasted" |
    "https=//w3id.org/xapi/dod-isd/verbs/tempered" |
    "https=//w3id.org/xapi/dod-isd/verbs/templated" |
    "http=//adlnet.gov/expapi/verbs/terminated" |
    "https=//w3id.org/xapi/dod-isd/verbs/tested" |
    "https=//w3id.org/xapi/dod-isd/verbs/threw" |
    "https=//w3id.org/xapi/dod-isd/verbs/tightened" |
    "https=//w3id.org/xapi/dod-isd/verbs/told" |
    "https=//w3id.org/xapi/dod-isd/verbs/took" |
    "https//w3id.org/xapi/dod-isd/verbs/took-charge" |
    "https//w3id.org/xapi/dod-isd/verbs/took-off" |
    "https=//w3id.org/xapi/dod-isd/verbs/traced" |
    "https=//w3id.org/xapi/dod-isd/verbs/tracked" |
    "https=//w3id.org/xapi/dod-isd/verbs/trained" |
    "https=//w3id.org/xapi/dod-isd/verbs/transferred" |
    "https=//w3id.org/xapi/dod-isd/verbs/translated" |
    "https=//w3id.org/xapi/dod-isd/verbs/transmitted" |
    "https=//w3id.org/xapi/dod-isd/verbs/transported" |
    "https=//w3id.org/xapi/dod-isd/verbs/traversed" |
    "https=//w3id.org/xapi/dod-isd/verbs/treated" |
    "https=//w3id.org/xapi/dod-isd/verbs/triaged" |
    "https=//w3id.org/xapi/dod-isd/verbs/troubleshot" |
    "https=//w3id.org/xapi/dod-isd/verbs/tuned" |
    "https=//w3id.org/xapi/dod-isd/verbs/turned" |
    "http=//id.tincanapi.com/verb/tweeted" |
    "https=//w3id.org/xapi/dod-isd/verbs/twisted" |
    "https=//w3id.org/xapi/dod-isd/verbs/typed" |
    "http=//id.tincanapi.com/verb/unfocused" |
    "https=//w3id.org/xapi/dod-isd/verbs/unloaded" |
    "https=//w3id.org/xapi/seriousgames/verbs/unlocked" |
    "http=//id.tincanapi.com/verb/unregistered" |
    "https=//w3id.org/xapi/medbiq/verbs/updated" |
    "https=//w3id.org/xapi/seriousgames/verbs/used" |
    "https=//w3id.org/xapi/dod-isd/verbs/utilized" |
    "https=//w3id.org/xapi/dod-isd/verbs/validated" |
    "https=//w3id.org/xapi/dod-isd/verbs/verified" |
    "http=//id.tincanapi.com/verb/viewed" |
    "https=//w3id.org/xapi/dod-isd/verbs/visualized" |
    "http=//adlnet.gov/expapi/verbs/voided" |
    "http//id.tincanapi.com/verb/voted-down" |
    "http//id.tincanapi.com/verb/voted-up" |
    "https=//w3id.org/xapi/dod-isd/verbs/waited" |
    "https=//w3id.org/xapi/adl/verbs/waived" |
    "https//w3id.org/xapi/dod-isd/verbs/war-gamed" |
    "https//w3id.org/xapi/acrossx/verbs/was-assigned" |
    "https=//w3id.org/xapi/acrossx/verbs/watched" |
    "https=//w3id.org/xapi/dod-isd/verbs/wore" |
    "https=//w3id.org/xapi/dod-isd/verbs/wrote" |
    "https=//w3id.org/xapi/dod-isd/verbs/zeroed";

export enum ActivityTypes {
    AREA = <any>"https://w3id.org/xapi/seriousgames/activity-types/area",
    ASSESSMENT = <any>"http://adlnet.gov/expapi/activities/assessment",
    ATTEMPT = <any>"http://adlnet.gov/expapi/activities/attempt",
    BLOCK = <any>"https://w3id.org/xapi/cmi5/activities/block",
    BLOG = <any>"http://id.tincanapi.com/activitytype/blog",
    BOOK = <any>"http://id.tincanapi.com/activitytype/book",
    CATEGORY = <any>"http://id.tincanapi.com/activitytype/category",
    CERTIFICATE = <any>"https://www.opigno.org/en/tincan_registry/activity_type/certificate",
    CHAPTER = <any>"http://id.tincanapi.com/activitytype/chapter",
    CHAT_CHANNEL = <any>"http://id.tincanapi.com/activitytype/chat-channel",
    CHAT_MESSAGE = <any>"http://id.tincanapi.com/activitytype/chat-message",
    CHECKLIST = <any>"http://id.tincanapi.com/activitytype/checklist",
    CHECKLIST_ITEM = <any>"http://id.tincanapi.com/activitytype/checklist-item",
    CODE_COMMIT = <any>"http://id.tincanapi.com/activitytype/code-commit",
    COLLABORATION = <any>"https://w3id.org/xapi/acrossx/activities/collaboration",
    COMMUNITY_SITE = <any>"http://id.tincanapi.com/activitytype/community-site",
    CONFERENCE = <any>"http://id.tincanapi.com/activitytype/conference",
    CONFERENCE_SESSION = <any>"http://id.tincanapi.com/activitytype/conference-session",
    CONFERENCE_TRACK = <any>"http://id.tincanapi.com/activitytype/conference-track",
    CONTROLLER = <any>"https://w3id.org/xapi/seriousgames/activity-types/controller",
    COURSE = <any>"https://w3id.org/xapi/cmi5/activities/course",
    CUTSCENE = <any>"https://w3id.org/xapi/seriousgames/activity-types/cutscene",
    DIALOG_TREE = <any>"https://w3id.org/xapi/seriousgames/activity-types/dialog-tree",
    DISCUSSION = <any>"http://id.tincanapi.com/activitytype/discussion",
    DOCUMENT = <any>"http://id.tincanapi.com/activitytype/document",
    DOUBT = <any>"http://id.tincanapi.com/activitytype/doubt",
    E_BOOK = <any>"https://w3id.org/xapi/acrossx/activities/e-book",
    EMAIL = <any>"http://id.tincanapi.com/activitytype/email",
    EMBEDDED_STRATEGY = <any>"http://id.tincanapi.com/activitytype/strategy-embedded",
    ENEMY = <any>"https://w3id.org/xapi/seriousgames/activity-types/enemy",
    ESSAY = <any>"http://id.tincanapi.com/activitytype/essay",
    FACE_TO_FACE_DISCUSSION = <any>"https://w3id.org/xapi/acrossx/activities/face-to-face-discussion",
    FILE = <any>"http://adlnet.gov/expapi/activities/file",
    FORUM_REPLY = <any>"http://id.tincanapi.com/activitytype/forum-reply",
    FORUM_TOPIC = <any>"http://id.tincanapi.com/activitytype/forum-topic",
    FREETEXT_ANNOTATION = <any>"http://www.risc-inc.com/annotator/activities/freetext",
    GOAL = <any>"http://id.tincanapi.com/activitytype/goal",
    GRADE_CLASSIFICATION = <any>"http://www.tincanapi.co.uk/activitytypes/grade_classification",
    HIGHLIGHTED_TEXT_ANNOTATION = <any>"http://risc-inc.com/annotator/activities/highlight",
    INSTANT_RESPONSE_SYSTEM = <any>"https://w3id.org/xapi/acrossx/activities/instant-response-system",
    INTERACTION = <any>"http://adlnet.gov/expapi/activities/interaction",
    ITEM = <any>"https://w3id.org/xapi/seriousgames/activity-types/item",
    KEYBOARD = <any>"https://w3id.org/xapi/seriousgames/activity-types/keyboard",
    LEARNING_PLAN = <any>"https://w3id.org/xapi/acrossx/activities/learning-plan",
    LEGACY_LEARNING_STANDARD = <any>"http://id.tincanapi.com/activitytype/legacy-learning-standard",
    LESSON = <any>"http://adlnet.gov/expapi/activities/lesson",
    LEVEL = <any>"https://w3id.org/xapi/seriousgames/activity-types/level",
    LINK = <any>"http://adlnet.gov/expapi/activities/link",
    LMS = <any>"http://id.tincanapi.com/activitytype/lms",
    MEDIA = <any>"http://adlnet.gov/expapi/activities/media",
    MEETING = <any>"http://adlnet.gov/expapi/activities/meeting",
    MENU = <any>"https://w3id.org/xapi/seriousgames/activity-types/menu",
    MESSAGE = <any>"https://w3id.org/xapi/acrossx/activities/message",
    MODULE = <any>"http://adlnet.gov/expapi/activities/module",
    MOUSE = <any>"https://w3id.org/xapi/seriousgames/activity-types/mouse",
    NON_PLAYER_CHARACTER = <any>"https://w3id.org/xapi/seriousgames/activity-types/non-player-character",
    NOTE = <any>"https://w3id.org/xapi/acrossx/activities/note",
    NOTE_ANNOTATION = <any>"http://risc-inc.com/annotator/activities/note",
    OBJECTIVE = <any>"http://adlnet.gov/expapi/activities/objective",
    ONLINE_DISCUSSION = <any>"https://w3id.org/xapi/acrossx/activities/online-discussion",
    PAGE = <any>"https://w3id.org/xapi/acrossx/activities/page",
    PARAGRAPH = <any>"http://id.tincanapi.com/activitytype/paragraph",
    PERFORMANCE = <any>"http://adlnet.gov/expapi/activities/performance",
    PLAYLIST = <any>"http://id.tincanapi.com/activitytype/playlist",
    PRINTED_ASSESSMENT = <any>"https://w3id.org/xapi/acrossx/activities/printed-assessment",
    PRINTED_BOOK = <any>"https://w3id.org/xapi/acrossx/activities/printed-book",
    PRINTED_WORKSHEET = <any>"https://w3id.org/xapi/acrossx/activities/printed-worksheet",
    PROFILE = <any>"http://adlnet.gov/expapi/activities/profile",
    PROJECT = <any>"http://id.tincanapi.com/activitytype/project",
    PROJECT_SITE = <any>"http://id.tincanapi.com/activitytype/project-site",
    QUEST = <any>"https://w3id.org/xapi/seriousgames/activity-types/quest",
    QUESTION = <any>"http://adlnet.gov/expapi/activities/question",
    RESEARCH_REPORT = <any>"http://id.tincanapi.com/activitytype/research-report",
    RESOURCE = <any>"http://id.tincanapi.com/activitytype/resource",
    REWARD = <any>"http://id.tincanapi.com/activitytype/reward",
    SALES_OPPORTUNITY = <any>"http://id.tincanapi.com/activitytype/sales-opportunity",
    SCENARIO = <any>"http://id.tincanapi.com/activitytype/scenario",
    SCHOOL_ASSIGNMENT = <any>"http://id.tincanapi.com/activitytype/school-assignment",
    SCREEN = <any>"https://w3id.org/xapi/seriousgames/activity-types/screen",
    SEARCH_ENGINE = <any>"https://w3id.org/xapi/acrossx/activities/search-engine",
    SECTION = <any>"http://id.tincanapi.com/activitytype/section",
    SECURITY_ROLE = <any>"http://id.tincanapi.com/activitytype/security-role",
    SERIOUS_GAME = <any>"https://w3id.org/xapi/seriousgames/activity-types/serious-game",
    SIMPLE_COLLECTION = <any>"http://id.tincanapi.com/activitytype/collection-simple",
    SIMULATION = <any>"http://adlnet.gov/expapi/activities/simulation",
    SLIDE = <any>"http://id.tincanapi.com/activitytype/slide",
    SLIDE_DECK = <any>"http://id.tincanapi.com/activitytype/slide-deck",
    SOLUTION = <any>"http://id.tincanapi.com/activitytype/solution",
    SOURCE = <any>"http://id.tincanapi.com/activitytype/source",
    STATUS_UPDATE = <any>"http://id.tincanapi.com/activitytype/status-update",
    STEP = <any>"http://id.tincanapi.com/activitytype/step",
    STRATEGY = <any>"http://id.tincanapi.com/activitytype/strategy",
    SUBCATEGORY = <any>"http://id.tincanapi.com/activitytype/subcategory",
    SUGGESTION = <any>"http://id.tincanapi.com/activitytype/suggestion",
    TAG = <any>"http://id.tincanapi.com/activitytype/tag",
    TEST_DATA_BATCH = <any>"http://id.tincanapi.com/activitytype/test-data-batch",
    TOUCHSCREEN = <any>"https://w3id.org/xapi/seriousgames/activity-types/touchscreen",
    TUTOR_SESSION = <any>"http://id.tincanapi.com/activitytype/tutor-session",
    TWEET = <any>"http://id.tincanapi.com/activitytype/tweet",
    UNDERLINE_ANNOTATION = <any>"http://risc-inc.com/annotator/activities/underline",
    UNIT_TEST = <any>"http://id.tincanapi.com/activitytype/unit-test",
    UNIT_TEST_SUITE = <any>"http://id.tincanapi.com/activitytype/unit-test-suite",
    USER_PROFILE = <any>"http://id.tincanapi.com/activitytype/user-profile",
    VIDEO = <any>"https://w3id.org/xapi/video/activity-type/video",
    VOCABULARY_WORD = <any>"http://id.tincanapi.com/activitytype/vocabulary-word",
    VOICEMAIL = <any>"http://id.tincanapi.com/activitytype/voicemail",
    WEBINAR = <any>"http://id.tincanapi.com/activitytype/webinar",
    WEBPAGE = <any>"https://w3id.org/xapi/acrossx/activities/webpage",
    ZONE = <any>"https://w3id.org/xapi/seriousgames/activity-types/zone"
}
